module.exports = __webpack_public_path__ + "static/img/labour-5.40b7030.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-5.png
// module id = Lklu
// module chunks = 1